import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOpening = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "a",
	xmlns: "http://www.w3.org/2000/svg",
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M28.25,16c-5.84,0-10.92,3.24-13.64,8.03-1.16-.58-2.47-.92-3.86-.92-4.83,0-8.75,3.98-8.75,8.89H44c0-8.84-7.05-16-15.75-16Z",
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.11,2c-4.04,0-7.56,2.24-9.44,5.55-.81-.4-1.71-.64-2.67-.64-3.34,0-6.05,2.75-6.05,6.15h29.05c0-6.11-4.88-11.07-10.89-11.07Z",
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 40,
			y1: 44.04,
			x2: 40,
			y2: 56.04,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 68.28,
			y1: 55.76,
			x2: 59.8,
			y2: 64.24,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 11.72,
			y1: 55.76,
			x2: 20.2,
			y2: 64.24,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.92,78.04c2.55-8.11,10.13-14,19.08-14s16.37,5.76,19,13.74",
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 0,
			y1: 78.04,
			x2: 80,
			y2: 78.04,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		})
	]
});
export default SvgOpening;
